module.exports = __webpack_public_path__ + "img/desktoptalent.f78ecff.png";